import React, { useEffect, useState } from "react";
import { NavbarInterna } from "../componentes/navbarInterna";
import { manejarError } from "../manejo_errores";
import { ContainerAdministracion } from "../componentes/containerAdministracion";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Alert } from "antd";
export const SeleccionarAsociacion = ({ sesion, setAlerta }) => {
	const manejarAlertas = (tipo, mensaje) => {
		// Usar setAlerta para mostrar la alerta
		setAlerta({ message: mensaje, type: tipo });
	};
	// console.log(sesion)
	const [asociaciones, setAsociaciones] = useState({});
	const navigate = useNavigate();

	useEffect(() => {
		(async () => {
			const asociaciones = await axios.get(
				process.env.REACT_APP_DOMINIO +
				`/admin/asociaciones`,
				{
					withCredentials: true,
					credentials: "include",
					headers: {
						"Content-Type": "application/json",
					},
				}
			);
			// console.log(asociaciones.data);
			setAsociaciones(asociaciones.data);
		})();
	}, []);

	const handlePost = async (id) => {
		try {
			const response = await axios.post(
				process.env.REACT_APP_DOMINIO + `/seleccionar-asociacion`,
				{ id_asociacion: id },
				{
					withCredentials: true,
					credentials: "include",
					headers: {
						"Content-Type": "application/json",
					},
				}
			);
			// console.log("Estado:",response.status)
			if (response.status === 200) {
				manejarAlertas("success","Bienvenido!")

				// console.log("respuesta", response.data.token);
				const now = new Date();
				const expiration = Math.floor((now.getTime() + 1 * 60 * 60 * 1000) / 1000);
				localStorage.setItem("administradoresSessionToken", response.data.token, expiration);
				navigate("/admin/");
			}

		} catch (error) {
			manejarAlertas("error",manejarError(error))
		}
	};
	return (
		<>
		
			<section
				id="seccionAdministracionMenu"
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					marginTop: "50px",

				}}>
				<h1 className="titulos">Seleccione su Asociación</h1>
			</section>

			<section
				style={{
					display: "flex",
					flexDirection: "row",
					flexWrap: "wrap",
					justifyContent: "center",
					alignItems: "center",
					gap: "150px",
					margin: "20px 0",
				}}>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: "row",
						columnGap: "150px",
						rowGap: "15px",
						justifyContent: "center",
						maxWidth: "1200px",
					}}>
					<div>
						<h2 style={{fontSize:"1em", color:"#223463"}}>Asociaciones vinculadas</h2>
						<ul style={{ listStyle: "none", padding: 0 }}>
							{asociaciones.length > 0 ? (asociaciones.map((asociacion) => (
								<li
									key={asociacion.id}
									style={{
										marginBottom: "10px",
										border: "1px solid #ccc",
										padding: "10px",
										borderRadius: "5px",
									}}>
									<strong>{asociacion.nombre}</strong> ({asociacion.siglas})
									<br />
									<small>
										Creado:{" "}
										{new Date(asociacion.fecha_creacion).toLocaleDateString()}
									</small>
									<br />
									<button
										onClick={() => handlePost(asociacion.id)}
										style={{
											marginTop: "10px",
											padding: "5px 10px",
											backgroundColor: "#BA1721",
											color: "#fff",
											border: "none",
											borderRadius: "5px",
											cursor: "pointer",
										}}>
										Gestionar
									</button>
								</li>
							)))
								:
								<p>No hay asociaciones disponibles.</p>}
						</ul>
					</div>

				</div>
				{sesion.super_admin ? (<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: "row",
						columnGap: "80px",
						rowGap: "15px",
						justifyContent: "center",
						maxWidth: "1600px",

					}}>
					<ContainerAdministracion 
						link="/admin/asociaciones" 
						texto="Asociaciones" 	
            			img="asociaciones.svg"
						descripcion={"Administrá tus asociaciones"} 
						ancho="auto"				
					/>
					<ContainerAdministracion 
						link="/admin/administradores" 
						texto="Usuarios Administradores" 
            			img="admin.svg" 
						descripcion={"Gestioná los administradores"}				
					/>
					<ContainerAdministracion 
						link="/admin/publicidades" 
						texto="Publicidades" 
            			img="publicidad.svg"
						descripcion={"Subir publicidades"} 				
					/>
					<ContainerAdministracion 
						link="" 
						texto="App Mundo Piloto" 
            			img="celular.svg"
						descripcion="Gestionar app"	
						modalAbrir={true}			
					/>

				</div>)
					:
					<>
					</>}
			</section>
		</>
	);
};
